export default __webpack_public_path__ + "d3138eea7de8c5218f21e7c4f2edd7ae.svg";